import * as React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import redCarpet from "../../../static/events";

export default function RedCarpet2022() {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photosToShow = isMd ? redCarpet : redCarpet.slice(0, redCarpet.length);

  return (
    <Box marginTop={{ xs: "5%", sm: "2%" }}>
      <ImageList sx={{ width: 1200, height: 2900 }} cols={8}>
        {photosToShow.map((item) => (
          <ImageListItem key={item.imgPath} rowHeight={164}>
            <img
              src={`${item.imgPath}?w=164&h=164&fit=crop&auto=format`}
              srcSet={`${item.imgPath}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
              alt={"2022 Red Carpet"}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}
